/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EnumerationOptionDto } from './EnumerationOptionDto';
import {
    EnumerationOptionDtoFromJSON,
    EnumerationOptionDtoFromJSONTyped,
    EnumerationOptionDtoToJSON,
} from './EnumerationOptionDto';
import type { RtSystemQuantityScopeDto } from './RtSystemQuantityScopeDto';
import {
    RtSystemQuantityScopeDtoFromJSON,
    RtSystemQuantityScopeDtoFromJSONTyped,
    RtSystemQuantityScopeDtoToJSON,
} from './RtSystemQuantityScopeDto';

/**
 * 
 * @export
 * @interface EnumerationQuantityUsageDto
 */
export interface EnumerationQuantityUsageDto {
    /**
     * 
     * @type {boolean}
     * @memberof EnumerationQuantityUsageDto
     */
    isUsageEnabled?: boolean;
    /**
     * 
     * @type {Array<EnumerationOptionDto>}
     * @memberof EnumerationQuantityUsageDto
     */
    enumerationOptions?: Array<EnumerationOptionDto> | null;
    /**
     * 
     * @type {Array<RtSystemQuantityScopeDto>}
     * @memberof EnumerationQuantityUsageDto
     */
    medicalSystemScope?: Array<RtSystemQuantityScopeDto> | null;
    /**
     * 
     * @type {Array<RtSystemQuantityScopeDto>}
     * @memberof EnumerationQuantityUsageDto
     */
    qaEquipmentScope?: Array<RtSystemQuantityScopeDto> | null;
    /**
     * 
     * @type {string}
     * @memberof EnumerationQuantityUsageDto
     */
    $type?: EnumerationQuantityUsageDtoTypeEnum;
}


/**
 * @export
 */
export const EnumerationQuantityUsageDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoEnumerationDtoEnumerationQuantityUsageDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.EnumerationDto.EnumerationQuantityUsageDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type EnumerationQuantityUsageDtoTypeEnum = typeof EnumerationQuantityUsageDtoTypeEnum[keyof typeof EnumerationQuantityUsageDtoTypeEnum];


/**
 * Check if a given object implements the EnumerationQuantityUsageDto interface.
 */
export function instanceOfEnumerationQuantityUsageDto(value?: unknown): value is EnumerationQuantityUsageDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(EnumerationQuantityUsageDtoTypeEnum)[0];
}

export function EnumerationQuantityUsageDtoFromJSON(json: any): EnumerationQuantityUsageDto {
    return EnumerationQuantityUsageDtoFromJSONTyped(json, false);
}

export function EnumerationQuantityUsageDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnumerationQuantityUsageDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isUsageEnabled': !exists(json, 'isUsageEnabled') ? undefined : json['isUsageEnabled'],
        'enumerationOptions': !exists(json, 'enumerationOptions') ? undefined : (json['enumerationOptions'] === null ? null : (json['enumerationOptions'] as Array<any>).map(EnumerationOptionDtoFromJSON)),
        'medicalSystemScope': !exists(json, 'medicalSystemScope') ? undefined : (json['medicalSystemScope'] === null ? null : (json['medicalSystemScope'] as Array<any>).map(RtSystemQuantityScopeDtoFromJSON)),
        'qaEquipmentScope': !exists(json, 'qaEquipmentScope') ? undefined : (json['qaEquipmentScope'] === null ? null : (json['qaEquipmentScope'] as Array<any>).map(RtSystemQuantityScopeDtoFromJSON)),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function EnumerationQuantityUsageDtoToJSON(value?: EnumerationQuantityUsageDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'isUsageEnabled': value.isUsageEnabled,
        'enumerationOptions': value.enumerationOptions === undefined ? undefined : (value.enumerationOptions === null ? null : (value.enumerationOptions as Array<any>).map(EnumerationOptionDtoToJSON)),
        'medicalSystemScope': value.medicalSystemScope === undefined ? undefined : (value.medicalSystemScope === null ? null : (value.medicalSystemScope as Array<any>).map(RtSystemQuantityScopeDtoToJSON)),
        'qaEquipmentScope': value.qaEquipmentScope === undefined ? undefined : (value.qaEquipmentScope === null ? null : (value.qaEquipmentScope as Array<any>).map(RtSystemQuantityScopeDtoToJSON)),
        '$type': value.$type,
    });
}

